import "../Blogs/Blogs.css";

const PageNotFound = () => {
  return (
    <div className="vertical-center">
      <div className="w-[200px] h-[150px] flex flex-col items-center justify-center mx-auto rounded-[10px] bg-[#adadad] shadow-sm text-center">
        <h1 className="text-[35px] font-extrabold text-red-700 mb-1">Error</h1>
        <p className="font-semibold text-[20px] text-slate-800">
          Page not found!
        </p>
      </div>
    </div>
  );
};

export default PageNotFound;
